module.exports = __webpack_public_path__ + "images/empty-todos-statistics-31cd21c4a17f61e4bbc8df1b38153fa0.png";